import React from "react";
import { SistemaComponenteInterno } from "~/pages/Sistema/componentes";
import { SLTableCell } from "~/pages/Sistema/componentes/SistemaList";
import { ThisTable } from "./styles";

function TableComponent() {
  return (
    <>
      <SistemaComponenteInterno>
        <ThisTable>
          <SLTableCell className="col-w-1" name="codigoDevice" inputfilter>
            Device
          </SLTableCell>
          <SLTableCell className="col-w-2" name="idAcesso">
           Id de Acesso
          </SLTableCell>
          <SLTableCell name="titulo" inputfilter>
            Titulo
          </SLTableCell>
          <SLTableCell className="col-w-3 truncate" name="pesquisa.titulo" inputfilter>
            Pesquisa Ativa
          </SLTableCell>
          <SLTableCell className="col-w-3 truncate" name="centroCusto.titulo" inputfilter>
            Centro de Custo
          </SLTableCell>
          <SLTableCell className="col-w-2 truncate" name="unidade.nome" inputfilter>
            Unidade
          </SLTableCell>
        </ThisTable>
      </SistemaComponenteInterno>
    </>
  );
}

export default TableComponent;
